<template>
  <section-page
    title="Contact Tags"
    description="Tags allow you to organize your contacts however you like."
  >
    <template v-slot:right>
      <button-outlined icon-left="plus" @click="$refs.tagModal.open()">
        New Tag
      </button-outlined>
    </template>

    <app-empty-message
      :count="tags.length"
      heading="You don't have any tags. Why don't you make one."
    >
      <table-default
        :table-data="tags"
        default-sort="label"
      >
        <b-table-column label="Label" field="label" sortable v-slot="props">
          {{ props.row.label }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="120" v-slot="props">
          <button-link @click="$refs.tagModal.open(props.row)">Manage</button-link>
        </b-table-column>
      </table-default>
    </app-empty-message>

    <modal-container>
      <modal-crud-form
        ref="tagModal"
        title="Contact Tag"
        form-component="tag-form">
      </modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
export default {
  name: "ContactTags",
  computed: {
    tags() {
      return this.$store.getters.contactTags;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
